import { createReducer } from '@reduxjs/toolkit';

import patchPrinterTasks from '../../thunks/printerTasks/patchPrinterTasks';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const patchPrinterTasksReducer = createReducer(initialState, {
  [patchPrinterTasks.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [patchPrinterTasks.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    loading: false,
    error: null,
    data,
  }),
  [patchPrinterTasks.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default patchPrinterTasksReducer;
